var regularVariants = {
    39403668078766: "Calming",
    39403688296622: "Pain Relief",
    39403685019822: "Skin & Coat",
    39474579898542: "Probiotic",
    39403667325102: "Hip & Joint",
    43119155380398: "Eye Support",
    43141744951470: "Multivitamin",
    43516552773806: "Anal Glands",
    43863228711086: "Allergy & Immune",
    44053690712238: "5-in-1 Dog Wash",
  },
  discountedVariants = {
    39475059392686: "Calming",
    39475084689582: "Pain Relief",
    39475091177646: "Skin & Coat",
    39475091898542: "Probiotic",
    39475072827566: "Hip & Joint",
    43119330295982: "Eye Support",
    43141757599918: "Multivitamin",
    43533318815918: "Anal Glands",
    43868109635758: "Allergy & Immune",
    44053697724590: "5-in-1 Dog Wash",
  },
  getUpsellBodyText = {
    39475091177646: "A powerful duo to protect from itching, allergies, paw biting and help renew your dog's coat. Try them for 50% off!",
    39475091898542: "Protect your dog inside and out by boosting their gut health and immunity from allergies. Try them for 50% off!",
    39475084689582: "The natural way to calming and relieving your pup of pain and stress, and they're delicious.",
    39475059392686: "These delicious chews help with separation anxiety, stress, travels and more! Try them for 50% off.",
    39475072827566: "Get to the root of the pain by supporting your dog's hip, joints and muscles with these delicious chews. Try them for 50% off!",
    43119330295982: "Get longer lasting results and keep your dog's vision in top shape with an extra jar at 50% off!",
    43141757599918: "Complete their diet with robust nutrition thanks to these 15-in 1 chews.",
    43533318815918: "Get rid of scooting, digestive issues and odors with these delicious chews at 50% off!",
    43868109635758: "We recommend another month's supply for more effective, longer lasting protection from allergies. Add another for 50% off!",
    44053697724590: "Running out of dog shampoo can be annoying. Click here to save $5 by adding an extra bottle!",
  },
  getUpsellImage = {
    39475059392686: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/calming.png",
    39475084689582: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/pairelief.png",
    39475091177646: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/skincoat.png",
    39475091898542: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/probiotic.png",
    39475072827566: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/hipjoint.png?v=12",
    43119330295982: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/eyesupport-cover.png?v=1658313904",
    43141757599918: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/multivitamin-cover.png?v=1658313905",
    43533318815918: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/analglands_x190.png?v=1667978221",
    43868109635758: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-allergy_x190.png?v=1680189123",
    44053697724590: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-shampoo1_x200.png?v=1690351334",
  },
  getUpsell = {
    39403668078766: 39475091898542, // Calming upsell is Probiotic
    39403688296622: 39475072827566, // Pain Relief upsell is Hip & Joint
    39403685019822: 39475091898542, // Skin & Coat upsell is Probiotic
    39474579898542: 39475091177646, // Probiotic upsell is Skin & Coat
    39403667325102: 39475084689582, // Hip & Joint upsell is Pain Relief
    43119155380398: 43141757599918, // Eye Support upsell is Multivitamin
    43141744951470: 39475091898542, // Multivitamin upsell is Probiotic
    43516552773806: 39475091898542, // AG is Probiotic
    43863228711086: 39475091177646, // Allergy is Skin & Coat
    44053690712238: 39475091177646, // Shampoo - Skin Coat
  },
  getDiscountedVariant = {
    39403668078766: 39475059392686,
    39403688296622: 39475084689582,
    39403685019822: 39475091177646,
    39474579898542: 39475091898542,
    39403667325102: 39475072827566,
    43119155380398: 43119330295982,
    43141744951470: 43141757599918,
    43516552773806: 43533318815918,
    43863228711086: 43868109635758,
    44053690712238: 44053697724590,
  },
  getSellingPlan = {
    //variant : sellingPlanID
    39474579898542: 499220654, //probiotic
    39403685019822: 497811630, // sking and coat
    39403668078766: 497778862, // calming
    39403667325102: 499187886, // hip and Joint
    39403688296622: 499155118, //pain relief
    39475091898542: 530743470, // probiotic
    39475091177646: 530710702, // skin and coat
    39475059392686: 530677934, // calming
    39475072827566: 530645166, // hip and Joint
    39475084689582: 530612398, // pain relief
    43141744951470: 2076213422,
    43141757599918: 2076246190,
    43119155380398: 2076278958,
    43119330295982: 2076311726,
    43516552773806: 2164719790,
    43533318815918: 2164687022,
    43868109635758: 2422407342,
    43863228711086: 2422374574,
    44053690712238: 2582282414,
    44053697724590: 2582249646,
  };

var Pawfy = {
  initUpsell: function (quantity, parentVariantID) {
    var upsellName = "",
      upsellVariantID = 0,
      upsellHeading = document.querySelector(".upsell b span"),
      upsellWrapper = document.querySelector(".upsell"),
      upsellBody = document.querySelector(".upsell p"),
      upsellImg = document.querySelector(".upsell img");
    if (document.body.classList.contains("product-page")) {
      parentVariantID = Number(document.querySelector("div#shopify-section-v5header + main").dataset.variant);
    }
    upsellWrapper.classList.remove("hip", "pain", "skin", "calming", "probiotic", "multivitamin", "eye", "5-in-1");

    if (parseInt(quantity) == 1) {
      upsellVariantID = getDiscountedVariant[parentVariantID];
      upsellName = String(regularVariants[parentVariantID]);
      upsellHeading.innerText = `Add Another ${parentVariantID == 44053690712238 ? "Bottle" : "Jar"} For Just $19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    } else {
      upsellVariantID = getUpsell[parentVariantID];
      upsellName = String(discountedVariants[upsellVariantID]);
      upsellHeading.innerText = `Add ${upsellName} Chews For Just $19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    }

    upsellWrapper.classList.add(upsellName.split(" ")[0].toLocaleLowerCase());
    upsellWrapper.dataset.variant = upsellVariantID;

    document.getElementById("addToCart").addEventListener("click", function (ev) {
      ev.preventDefault();

      var xhr = new XMLHttpRequest(),
        isSubscription = document.querySelector("[value='subsave']").checked;
      var items = isSubscription
        ? [
            {
              quantity: document.querySelector(".upsell__check").checked ? 1 : 0,
              id: document.querySelector(".upsell").dataset.variant,
              selling_plan: getSellingPlan[document.querySelector(".upsell").dataset.variant],
              properties: {
                Promo: "AutoShip Offer",
              },
            },
            {
              quantity: Number(document.querySelector("[name='qty']:checked").value),
              id: document.querySelector("div#shopify-section-v5header + main").dataset.variant,
              selling_plan: getSellingPlan[Number(document.querySelector("div#shopify-section-v5header + main").dataset.variant)],
              properties: {
                Promo: "AutoShip Offer",
              },
            },
          ]
        : [
            {
              quantity: document.querySelector(".upsell__check").checked ? 1 : 0,
              id: document.querySelector(".upsell").dataset.variant,
              properties: {
                Promo: "Product Upsell",
              },
            },
            {
              quantity: Number(document.querySelector("[name='qty']:checked").value),
              id: document.querySelector("div#shopify-section-v5header + main").dataset.variant,
              properties: {
                Promo: "Product Upsell",
              },
            },
          ];
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          window.location.href = "/cart";
        }
      };

      xhr.open("POST", "/cart/add.js", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(
        JSON.stringify({
          attributes: {
            Special: "Product Special",
          },
          items: items,
        })
      );
    });
  },
  randomInteger: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  initCarousels: function () {
    if (document.getElementById("homepage-product-slider")) {
      new Splide("#homepage-product-slider", {
        type: "loop",
        perPage: 3,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: false,
        padding: 16,
        interval: 6000,
        pagination: false,
        arrows: true,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        breakpoints: {
          767: {
            perPage: 2,
          },
          1024: {
            perPage: 2,
          },
        },
      }).mount();
    }
    if (document.getElementById("product-slider")) {
      new Splide("#product-slider", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: false,
        interval: 6000,
        pagination: false,
        padding: window.innerWidth <= 820 ? 10 : 48,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        arrows: true,
      }).mount();
    }
    if (window.innerWidth <= 560 && document.getElementById("inside")) {
      new Splide("#inside", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 0 : 48,
        autoplay: false,
        interval: 6000,
        pagination: false,
        padding: window.innerWidth <= 820 ? 0 : 48,
        arrows: true,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        breakpoints: {
          560: {
            perPage: 1,
          },
          820: {
            perPage: 2,
          },
        },
      }).mount();
    }
    if (document.getElementById("two-packs")) {
      if (window.innerWidth <= 1023) {
        new Splide("#two-packs", {
          type: "loop",
          perPage: 1,
          gap: 32,
          autoplay: false,
          interval: 6000,
          autoHeight: true,
          pagination: false,
          padding: 32,
          arrows: true,
          breakpoints: {
            1023: {
              perPage: 2,
            },
            767: {
              perPage: 1,
            },
          },
          arrowPath:
            "M13.8457 17.718C13.4591 17.718 13.1457 18.0314 13.1457 18.418C13.1457 18.8046 13.4591 19.118 13.8457 19.118L13.8457 17.718ZM26.8016 18.9129C27.0749 18.6396 27.0749 18.1964 26.8016 17.923L22.3468 13.4682C22.0734 13.1949 21.6302 13.1949 21.3568 13.4682C21.0835 13.7416 21.0835 14.1848 21.3568 14.4582L25.3166 18.418L21.3568 22.3778C21.0835 22.6511 21.0835 23.0943 21.3568 23.3677C21.6302 23.6411 22.0734 23.6411 22.3468 23.3677L26.8016 18.9129ZM13.8457 19.118L26.3066 19.118L26.3066 17.718L13.8457 17.718L13.8457 19.118Z",
        }).mount();
      }
    }
    if (document.getElementById("testimonials-new")) {
      if (window.innerWidth >= 820) {
        document.querySelectorAll("#testimonials-new li.mobile-show").forEach((button) => {
          button.remove();
        });
      } else {
        document.querySelectorAll("#testimonials-new li:not(.mobile-show)").forEach((button) => {
          button.remove();
        });
      }
      var splide = new Splide("#testimonials-new", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: false,
        interval: 6000,
        autoHeight: true,
        focus: "center",
        pagination: false,
        padding: window.innerWidth <= 820 ? 48 : 24,
        arrows: true,
        arrowPath:
          "M13.8457 17.718C13.4591 17.718 13.1457 18.0314 13.1457 18.418C13.1457 18.8046 13.4591 19.118 13.8457 19.118L13.8457 17.718ZM26.8016 18.9129C27.0749 18.6396 27.0749 18.1964 26.8016 17.923L22.3468 13.4682C22.0734 13.1949 21.6302 13.1949 21.3568 13.4682C21.0835 13.7416 21.0835 14.1848 21.3568 14.4582L25.3166 18.418L21.3568 22.3778C21.0835 22.6511 21.0835 23.0943 21.3568 23.3677C21.6302 23.6411 22.0734 23.6411 22.3468 23.3677L26.8016 18.9129ZM13.8457 19.118L26.3066 19.118L26.3066 17.718L13.8457 17.718L13.8457 19.118Z",
      }).mount();
      setTimeout(function () {
        splide.go(">");
        setTimeout(function () {
          splide.go("<");
        }, 500);
      }, 400);
    }
  },
  customSticky: function () {
    if (window.scrollY >= 10) {
      document.querySelector("header.header").classList.add("header--sticky");
    } else {
      document.querySelector("header.header").classList.remove("header--sticky");
    }
  },
  initResponsiveMenu: function () {
    document.querySelector(".menu-toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector("header.header").classList.toggle("active");
      document.querySelector("header.header ul").classList.toggle("active");
    });
  },
  createElementFromHTML: function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },
  initFAQ: function () {
    var questions = document.querySelectorAll(".faq__list-question");
    for (var j = 0; j < questions.length; j++) {
      questions[j].addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        var that = this;
        if (that.classList.contains("active")) {
          that.nextElementSibling.classList.remove("active");
          that.classList.remove("active");
        } else {
          var answers = document.querySelectorAll(".faq__list-answer");

          for (var i = 0; i < answers.length; i++) {
            answers[i].classList.remove("active");
          }

          for (var j = 0; j < questions.length; j++) {
            questions[j].classList.remove("active");
          }

          that.classList.add("active");
          that.nextElementSibling.classList.add("active");
        }
      });
    }
  },
  insertAfter: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  },
  insertBefore: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode);
  },
  toggleTabs: function () {
    var tabs = document.querySelectorAll(".pawfy-tab__header-item"),
      contents = document.querySelectorAll(".pawfy-tab__content-item");
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].addEventListener("click", function () {
        for (var c = 0; c < contents.length; c++) {
          contents[c].classList.remove("active");
          tabs[c].classList.remove("active");
        }
        this.classList.add("active");
        document.querySelector(".pawfy-tab__content-item[data-id='" + this.dataset.id + "']").classList.add("active");
      });
    }
  },
  rewordReCharge: function () {
    var root = document.querySelector("#ReCharge.user-customer");
    var customer =
      Pawfy.getCookie("subscription_customer").length > 5 ? JSON.parse(Pawfy.getCookie("subscription_customer")) : JSON.parse(JSON.stringify({ isSub: false, email: "" }));
    var isSub = customer.isSub,
      customerEmail = customer.email;
    document.body.classList.add("recharge-login");
    var sectionTitle = document.querySelector("#ReCharge.user-customer").querySelector("h2");
    var sectionBody = document.querySelector("#ReCharge.user-customer").querySelector(".rc_header-settings__description p");
    if (sectionBody) {
      if (isSub && !!document.getElementById("customer_email")) {
        sectionTitle.innerText = "Access Your Subscription";
        sectionBody.innerHTML = "We have detected a subscription account with this e-mail.<br> Click 'Submit' to get access to your account.";
        document.getElementById("customer_email").value = customerEmail;
        //document.getElementById("login_verification").submit();
        root.style.opacity = 1;
      } else {
        sectionTitle.innerText = "Access Your Subscription";
        sectionBody.innerText =
          "Please provide the e-mail used for your order to complete your account setup. Once complete, you can change, skip or cancel your subscription directly within your account.";
        Pawfy.insertAfter(
          Pawfy.createElementFromHTML(`<p><br>Alternatively, contact us on <a href="mailto:care@pawfy.com">care@pawfy.com</a> for assistance.</p>`),
          document.querySelector("#login_verification")
        );
        root.style.opacity = 1;
      }
    } else {
      if (isSub) {
        document.querySelector("#ReCharge.user-customer").querySelector("p.rc_form__placeholder").innerHTML = `
We have sent you an e-mail to: <b>${customerEmail}</b><br>
Please check your inbox (including spam) for a link to access your subscription.
`;
      }
      root.style.opacity = 1;
    }
  },
  setCookie: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  initNotification: function () {
    var notificationEl = document.getElementById("pawfy-notification");
    if (notificationEl.innerText.trim().length > 10) {
      let notification = Pawfy.getCookie("notification");
      if (notification !== "true") {
        notificationEl.style.display = "block";
        notificationEl.classList.remove("inactive");
      }
      document.getElementById("close-notification").addEventListener("click", function () {
        Pawfy.setCookie("notification", "true", 10);
        notificationEl.classList.add("inactive");
      });
    }
  },
  initReviews: function () {
    document.getElementById("submit").addEventListener("click", function (ev) {
      if (!document.getElementById("newReview").checkValidity()) return false;
      document.querySelector(".confirmation img").src = document.querySelector(".confirmation img").src;
      document.querySelector(".confirmation").classList.add("show");
      setTimeout(function () {
        document.querySelector(".reviews-modal").classList.remove("visible");
        document.querySelector(".confirmation").classList.remove("show");
      }, 2000);
    });
    var rateStars = document.getElementsByName("rating"),
      allReviews = document.querySelectorAll("[data-rating]"),
      readmores = document.querySelectorAll(".read-more");

    for (var s = 0; s < rateStars.length; s++) {
      if (!rateStars[s]) return false;
      rateStars[s].addEventListener("click", function (ev) {
        var rating = this.value;
        var filtered = document.querySelectorAll("[data-rating='" + rating + "']");
        for (var a = 0; a < allReviews.length; a++) {
          var item = allReviews[a];
          item.classList.add("hide-animate");
        }
        setTimeout(function () {
          for (var a = 0; a < allReviews.length; a++) {
            var item = allReviews[a];
            item.classList.remove("show");
            item.classList.remove("show-animate");
            item.classList.add("hide");
          }
          for (var f = 0; f < filtered.length; f++) {
            var item = filtered[f];
            item.classList.add("show");
            item.classList.remove("hide");
            item.classList.remove("hide-animate");
          }

          setTimeout(function () {
            for (var f = 0; f < filtered.length; f++) {
              var item = filtered[f];
              item.classList.add("show-animate");
            }
          }, 300);
        }, 300);

        if (filtered.length == 0) {
          document.querySelector(".reviews-list__footer").classList.add("hide");
        } else {
          document.querySelector(".reviews-list__footer").classList.remove("hide");
        }
      });
    }

    for (var r = 0; r < readmores.length; r++) {
      if (!readmores[r]) return false;
      readmores[r].addEventListener("click", function (ev) {
        ev.preventDefault();
        this.closest("p").classList.add("active");
        this.remove();
      });
    }
    var currentPage = 1;
    document.getElementById("appendMoreReviews").addEventListener("click", (ev) => {
      ev.preventDefault();
      currentPage = currentPage + 1;
      if (currentPage == 4) {
        document.getElementById("appendMoreReviews").remove();
      }
      document.getElementById("reviewsList").dataset.page = currentPage;
    });
    document.getElementById("leaveReview").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.add("visible");
    });
    document.getElementById("closeModal").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.remove("visible");
    });
  },
  randomizeReviews: function () {
    var strings = ["Today", "1 Day Ago", "2 Days Ago", "3 Days Ago", "4 Days Ago", "Last Week", "Last Month"];
    var waybacks = document.querySelectorAll(".testimonials__card-author small");
    for (var i = 0; i < waybacks.length; i++) {
      waybacks[i].innerText = strings[Pawfy.randomInteger(0, 6)];
    }
  },
  upsellToggles: function () {
    var upsellToggles = document.querySelectorAll(".upsellToSub__input");
    for (var j = 0; j < upsellToggles.length; j++) {
      upsellToggles[j].addEventListener("change", function () {
        var controls = this.closest("tr").querySelectorAll("label.upsellToSub");

        [].forEach.call(controls, (el) => {
          el.classList.add("active");
        });
        var theVariant = this.value.split(":")[0],
          qty = this.dataset.qty;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var xhrSUB = new XMLHttpRequest();
            xhrSUB.onreadystatechange = function () {
              if (xhrSUB.readyState == 4 && xhrSUB.status == 200) {
                window.location.href = "/cart";
              }
            };
            xhrSUB.open("POST", "/cart/add.js", true);
            xhrSUB.setRequestHeader("Content-Type", "application/json");
            xhrSUB.send(
              JSON.stringify({
                items: [
                  {
                    quantity: qty,
                    id: theVariant,
                    selling_plan: getSellingPlan[theVariant],
                  },
                ],
              })
            );
          }
        };
        xhr.open("POST", "/cart/change.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send("line=" + this.closest("td").closest("tr").dataset.cartItemIndex + "&quantity=0");
      });
    }
  },
  initSubFlow: function () {
    Pawfy.setCookie("subscription_customer", JSON.stringify({ isSub: true, email: "" }), 365);
    if (document.body.classList.contains("recharge-login")) {
      var customer = JSON.parse(Pawfy.getCookie("subscription_customer"));
      var isSub = customer.isSub,
        customerEmail = customer.email;
      if (isSub && !!document.getElementById("customer_email")) {
        document.getElementById("customer_email").value = customerEmail;
        document.getElementById("login_verification").submit();
      }
    }
  },
  initBundler: function (js) {
    if (document.querySelectorAll(".addMultiple").length > 0) {
      var bundlers = document.querySelectorAll(".addMultiple");

      for (var i = 0; i < bundlers.length; i++) {
        bundlers[i].addEventListener("click", function (ev) {
          ev.preventDefault();
          var items = this.dataset.variants.split(","),
            itemsArray = [];
          for (var j = 0; j < items.length; j++) {
            itemsArray.push({
              quantity: 1,
              id: parseInt(items[j]),
              properties: {
                Promo: "Multipack Bundles (" + items.length + ")",
              },
            });
          }
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              window.location.href = "/cart";
            }
          };
          xhr.open("POST", "/cart/add.js", true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(
            JSON.stringify({
              attributes: {
                Promo4: itemsArray.length + " Pack Bundle",
              },
              items: itemsArray,
            })
          );
        });
      }
    }
  },
  disableEmptyAddToCart: function (js) {
    var addToCart = document.getElementById("addToCart");
    var choices = document.querySelectorAll('[name="qty"]');
    addToCart.classList.add("disabled");
    for (i = 0; i < choices.length; i++) {
      choices[i].addEventListener("click", function () {
        addToCart.classList.remove("disabled");
      });
    }
  },
  productQuantitySelectorsBind: function (js) {
    var dropElement = document.querySelector("ul.product-atf__qty"),
      types = document.querySelectorAll('[name="type"]'),
      quantities = document.querySelectorAll('[name="qty"]'),
      monthlySmall = document.querySelector("small.monthly");

    for (var j = 0; j < quantities.length; j++) {
      quantities[j].addEventListener("click", function (ev) {
        var lis = this.closest("ul").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("come-first");
        }

        this.closest("li").classList.add("come-first");
        dropElement.classList.toggle("dropped");
        Pawfy.initUpsell(this.value);
      });
    }

    for (var j = 0; j < types.length; j++) {
      types[j].addEventListener("change", function () {
        var theClass = document.querySelector('[name="type"]:checked').value;
        dropElement.classList.remove("subsave", "ss", "otp");
        dropElement.classList.add(theClass);
        if (theClass == "ss") {
          monthlySmall.classList.add("active");
        } else {
          monthlySmall.classList.remove("active");
        }
      });
    }
  },
  cartManipulations: function (js) {
    var cartRows = document.querySelectorAll('[action="/cart"] tr.cart__row');

    for (var j = 0; j < cartRows.length; j++) {
      var that = cartRows[j];
      var variant = that.dataset.cartItemKey.split(":")[0];
      var qty = that.dataset.cartItemQuantity;

      if (that.querySelector(".product-details [data-cart-item-property-value]").innerText.toLowerCase().indexOf("autoship") > -1) {
        that.querySelector("ul.order-discount").classList.remove("hide");
        var ul = that.querySelector("ul.order-discount");
        ul.innerHTML = "";
        var li = document.createElement("li");
        li.classList.add("order-discount__item", "pawfy", "subscription");
        li.innerHTML =
          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg><span data-cart-item-discount-title="">subscription</span>';
        ul.appendChild(li);
      }
      if (Object.getOwnPropertyNames(discountedVariants).includes(String(variant))) {
        that.classList.add("target-offer-killed");
        that.dataset.variant = variant;
      } else {
        that.classList.add("target-offer-killer");
        that.dataset.variant = variant;
        that.dataset.killVariant = getUpsell[variant];
        if (qty > 1) {
          that.querySelector(".cart__image-wrapper a").dataset.variant = variant;
          that.querySelector(".cart__image-wrapper a").dataset.killVariant = getUpsell[variant];
        } else {
          that.querySelector(".cart__image-wrapper a").dataset.variant = variant;
          that.querySelector(".cart__image-wrapper a").dataset.killVariant = getDiscountedVariant[variant];
        }
        that.querySelector(".cart__image-wrapper a").addEventListener("click", function (ev) {
          ev.preventDefault();
          var thus = this;
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              location.reload();
              Pawfy.cartManipulations();
            }
          };
          xhr.open("POST", "/cart/update.js", true);
          xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

          if (thus.dataset.killVariant !== "undefined") {
            xhr.send("updates[" + thus.dataset.variant + "]=0&updates[" + thus.dataset.killVariant + "]=0");
          } else {
            xhr.send("updates[" + thus.dataset.variant + "]=0");
          }
        });
      }
    }
    var increments = document.getElementsByClassName("increment"),
      decrements = document.getElementsByClassName("decrement");
    for (var i = 0; i < increments.length; i++) {
      increments[i].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepUp();
      });
    }

    for (var d = 0; d < decrements.length; d++) {
      decrements[d].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepDown();
      });
    }

    if (document.querySelector('[name="checkout"]')) {
      var selector = document.querySelector('[data-cart-wrapper] > [name="checkout"]');
      if (selector) {
        selector.remove();
      }

      if (document.querySelector(".cart-header ~ input")) {
        document.querySelector(".cart-header ~ input").remove();
      }
    }
  },
  cartUpsell: function (js) {
    var pricing = document.querySelectorAll(".cart-subtotal__price");
    var value = Number(pricing[0].innerText.replace(/[^0-9\.-]+/g, ""));
    if (value <= 45 && document.querySelectorAll(".order-discount__item.pawfy").length == 0) {
      document.querySelector(".cart-header").classList.add("show");
    }
    document.querySelector(".upsell__check").addEventListener("change", function () {
      for (var i = 0; i < pricing.length; i++) {
        pricing[i].innerText = "$" + (this.checked ? value + 19.99 : value).toFixed(2) + " USD";
      }
    });
    var xmlhttp = new XMLHttpRequest(),
      smallest = 100,
      upsellItem = {};
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        if (xmlhttp.status == 200) {
          var itemsArray = JSON.parse(xmlhttp.responseText).items;

          for (var productItem in itemsArray) {
            var quantity = itemsArray[productItem].quantity;
            if (quantity < smallest && Object.getOwnPropertyNames(regularVariants).includes(String(itemsArray[productItem].id))) {
              smallest = quantity;
              upsellItem = itemsArray[productItem];
            }
          }

          var rogueRows = document.querySelectorAll("tr.cart__row.offer"),
            regularRows = document.querySelectorAll("tr.cart__row:not(.offer)");

          if (rogueRows.length > 0 && regularRows.length == 0) {
            var updateString = "updates[" + rogueRows[0].dataset.cartItemKey.split(":")[0] + "]=0";
            for (var i = 1; i < rogueRows.length; i++) {
              updateString = updateString + "&updates[" + rogueRows[i].dataset.cartItemKey.split(":")[0] + "]=0";
              rogueRows[i].remove();
            }
            document.querySelector(".cart-right").remove();
            document.querySelector('[action*="/cart"]').remove();
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 4 && xhr.status == 200) {
                location.reload();
              }
            };
            xhr.open("POST", "/cart/update.js", true);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

            xhr.send(updateString);

            return false;
          }
          if (!document.querySelector('[action="/cart"] tr.cart__row')) {
            return false;
          }
          var currentName = String(discountedVariants[getDiscountedVariant[upsellItem.id]]);
          var upsells = document.querySelectorAll(".discounted-product");
          var upsellParent = false;

          for (i = 0; i < upsells.length; i++) {
            upsellParent = document.querySelector("[data-kill-variant='" + upsells[i].dataset.variant + "']");
          }

          document.querySelector(".upsell__image").style.backgroundImage = `url('${getUpsellImage[getDiscountedVariant[upsellItem.id]]}')`;
          document.querySelector(".upsell__image").classList.add(currentName.split(" ")[0].toLowerCase());
          document.querySelector(".cart_upsell").classList.add("active");

          var checkouts = document.querySelectorAll(".cart__submit.btn.btn--small-wide");

          for (i = 0; i < checkouts.length; i++) {
            checkouts[i].addEventListener("click", function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              if (document.querySelector(".upsell__check").checked) {
                var xhr = new XMLHttpRequest();
                var xhrSUB = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                  if (xhr.readyState == 4 && xhr.status == 200) {
                    window.location.href = "/checkout";
                  }
                };
                xhr.open("POST", "/cart/add.js", true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(
                  JSON.stringify({
                    attributes: {
                      Promo3: "Cart Special",
                    },
                    items: [
                      {
                        quantity: 1,
                        id: getDiscountedVariant[upsellItem.id],
                        properties: {
                          Promo: "Cart Special",
                        },
                      },
                    ],
                  })
                );
              } else {
                window.location.href = "/checkout";
              }
            });
          }
        } else if (xmlhttp.status == 400) {
          alert("There was an error 400");
        } else {
          alert("something else other than 200 was returned");
        }
      }
    };

    xmlhttp.open("GET", "/cart.js", true);
    xmlhttp.send();
  },
  klaviyoChecker: function (js) {
    var klaviyoAppeared = false;
    var klaviyoChecker = setInterval(function () {
      if (!klaviyoAppeared) {
        klaviyoAppeared = document.querySelector(".klaviyo-pawfy form");
      } else {
        var klaviyos = document.querySelectorAll("[class*='kl-private-reset-css']");
        for (var j = 0; j < klaviyos.length; j++) {
          klaviyos[j].removeAttribute("class");
        }
        document.querySelectorAll(".klaviyo-pawfy form > div > [data-testid]:last-child").forEach((testid) => {
          testid.classList.add("input-block", "input-block--flat-on-mobile");
        });

        document.querySelectorAll(".klaviyo-pawfy").forEach((testid) => {
          testid.classList.add("active");
        });
        clearInterval(klaviyoChecker);
      }
    }, 500);
  },
  getTransactionID: function () {
    const url = new URL(document.location.href);
    const searchParams = url.searchParams;

    var transactionID = searchParams.get("transaction_id");
    if (transactionID) {
      localStorage.setItem("transactionID", transactionID);
    }
  },
  pushTransactionID: function () {
    var transactionID = localStorage.getItem("transactionID");
    if (transactionID) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          console.log("successfully transferred transaction ID", transactionID);
        }
      };
      xhr.open("POST", "https://pawfy.go2cloud.org/", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.send("aff_lsr?offer_id=1&transaction_id=" + transactionID);
    }
  },
  initFloaterATC: function () { 
    var el = document.querySelector(".floater-atc"),
      atcElement = document.getElementById("addToCart"),
      atcPosition = window.scrollY + atcElement.getBoundingClientRect().top;
    el.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (atcElement.getAttribute("disabled") == null) {
        atcElement.click();
      } else {
        document.querySelector(".buy-ribbon__wrapper a").click();
      }
    });
    window.addEventListener("scroll", function(e){
	  if (window.scrollY > atcPosition) {
        el.classList.add("active");
      } else {
        el.classList.remove("active"); 
      }
});
   
  },
};

Pawfy.customSticky();
Pawfy.initResponsiveMenu();
setTimeout(function () {
  Pawfy.initNotification();
}, 1000);
Pawfy.getTransactionID();

if (document.body.classList.contains("product-page")) {
  Pawfy.productQuantitySelectorsBind();
  Pawfy.disableEmptyAddToCart();
  //Pawfy.initFloaterATC();
}
if (document.body.classList.contains("reviews")) {
  //Pawfy.initReviews();
  //Pawfy.randomizeReviews();
}
if (
  document.body.classList.contains("contact-us") ||
  document.body.classList.contains("template-customers-login") ||
  document.body.classList.contains("template-customers-register")
) {
  Pawfy.toggleTabs();
}
if (document.body.classList.contains("template-cart")) {
  Pawfy.cartManipulations();
  Pawfy.cartUpsell();
  Pawfy.upsellToggles();
}
if (!document.body.classList.contains("template-cart")) {
  Pawfy.initCarousels();
  Pawfy.initFAQ();
  Pawfy.initBundler();
  Pawfy.klaviyoChecker();
}
window.onscroll = function () {
  Pawfy.customSticky();
};

if (document.body.classList.contains("template-")) {
  Pawfy.rewordReCharge();
}
